import React from 'react';
import { CheckCircle2, CalendarDays, User } from 'lucide-react';
import { addDaysToLADateKey, formatLADateRangeArrow } from '../../utils/laDateUtils';

const RoomCard = ({
  group,
  index,
  guestNames,
  cancelling,
  cancelError,
  confirmCancelOpen,
  onEdit,
  onCancelRequest,
  onCancelConfirm,
  onCancelKeep,
  onViewCalendar,
  showFooter = true,
}) => {
  const total = Number(group.price || 0) * (group.nights || 0);

  return (
    <div className="pbt-room-card">
      <div className="pbt-room-card__header">
        <span className="pbt-room-card__label">Room {index + 1}</span>
        <span className="pbt-room-card__check"><CheckCircle2 size={14} /></span>
      </div>

      <div className="pbt-room-card__body">
        <div className="pbt-room-card__hotel">{group.hotel_name}</div>
        <div className="pbt-room-card__room">{group.room_type} · {group.room_label}</div>
        {group.from_date && group.to_date && (
          <div className="pbt-room-card__dates">
            {formatLADateRangeArrow(group.from_date, addDaysToLADateKey(group.to_date, 1))}
          </div>
        )}

        <div className="pbt-room-card__pills">
          <span className={`pbt-alloc-pill ${group.allocation_type === 'private' ? 'pbt-alloc-pill--private' : 'pbt-alloc-pill--required'}`}>
            {group.allocation_type === 'private' ? 'Private' : 'Required'}
          </span>
          {group.is_guest_only && <span className="pbt-guest-only-pill">Guest only</span>}
        </div>

        <div className="pbt-room-card__price-block">
          <span>${group.price}/night</span>
          <span className="pbt-room-card__total">${total.toLocaleString()} total</span>
        </div>

        <span className="pbt-room-card__nights">{group.nights} night{group.nights === 1 ? '' : 's'}</span>

        {guestNames.length > 0 && (
          <div className="pbt-room-card__guests">
            <User size={11} />
            <span>{guestNames.length} guest{guestNames.length !== 1 ? 's' : ''}: {guestNames.join(', ')}</span>
          </div>
        )}
      </div>

      {cancelError && <div className="pbt-panel__error">{cancelError}</div>}

      {showFooter && (
        confirmCancelOpen ? (
          <div className="pbt-inline-cancel">
            <span>Cancel this booking? This cannot be undone.</span>
            <div className="pbt-inline-cancel__actions">
              <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onCancelKeep}>Keep</button>
              <button type="button" className="btn btn-sm btn-danger" onClick={onCancelConfirm} disabled={cancelling}>
                {cancelling ? 'Cancelling…' : 'Cancel Booking'}
              </button>
            </div>
          </div>
        ) : (
          <div className="pbt-room-card__footer">
            <button type="button" className="pbt-room-card__link" aria-label="View in Calendar" onClick={onViewCalendar}>
              <CalendarDays size={13} /> Calendar
            </button>
            <span className="pbt-room-card__divider" />
            <button type="button" className="pbt-room-card__link" onClick={onEdit}>Edit</button>
            <span className="pbt-room-card__divider" />
            <button type="button" className="pbt-room-card__link pbt-room-card__link--danger" onClick={onCancelRequest} disabled={cancelling}>
              {cancelling ? 'Cancelling…' : 'Cancel'}
            </button>
          </div>
        )
      )}
    </div>
  );
};

export default RoomCard;
